export default function removeUnderlineStyles(html) {
    return html.replace(/text-decoration:\s*underline;?/gi, "");
}